// Analytics du site : (1) first-party auto-hébergé O2switch (/api/track.php, zéro cookie),
// (2) Google Tag Manager + GA4 (activés dès que GTM_ID/GA4_ID sont renseignés, sinon inertes).
// Dégradation gracieuse : en local sans PHP / sans ID Google, tout échoue en silence.

// ⚙️ Renseigner pour activer Google (laisser vide = inerte) :
export const GTM_ID = ''; // ex. 'GTM-XXXXXXX'
export const GA4_ID = ''; // ex. 'G-XXXXXXXXXX' (utilisé seulement si GTM_ID est vide)

const ENDPOINT = '/api/track.php';

// ——— Analytics first-party ———
export function track(type, data = {}) {
  try {
    const payload = JSON.stringify({
      type,
      path: data.path || window.location.pathname,
      label: data.label || '',
      ref: document.referrer ? new URL(document.referrer).hostname : '',
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(ENDPOINT, { method: 'POST', body: payload, keepalive: true }).catch(() => {});
    }
  } catch {
    /* jamais bloquant pour l'UX */
  }
}

// ——— Couche dataLayer / GTM ———
export function dl(obj) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
  } catch {
    /* noop */
  }
}

let gtmInjected = false;
/** Injecte GTM (ou GA4 direct si pas de GTM). Appelé une fois au montage de l'app. */
export function initAnalytics() {
  if (gtmInjected) return;
  gtmInjected = true;
  window.dataLayer = window.dataLayer || [];
  if (GTM_ID) {
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
    document.head.appendChild(s);
  } else if (GA4_ID) {
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
    document.head.appendChild(s);
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA4_ID);
  }
}

/** Pageview SPA : beacon first-party + dataLayer (pour GA4 via GTM). */
export function trackPageview(path) {
  track('pageview', { path });
  dl({ event: 'page_view_spa', page_path: path });
}

/** Conversion (envoi de formulaire) — repérable comme conversion GA4 / Google Ads. */
export function trackLead(form, interests) {
  dl({ event: 'generate_lead', form, interests: interests || [] });
}

let ctaListenerArmed = false;
/** Écoute globale des clics sur tout élément portant data-cta (liens, boutons). */
export function armCtaTracking() {
  if (ctaListenerArmed) return;
  ctaListenerArmed = true;
  document.addEventListener(
    'click',
    (e) => {
      const el = e.target.closest && e.target.closest('[data-cta]');
      if (el) {
        const cta = el.getAttribute('data-cta');
        track('cta', { label: cta });
        dl({ event: 'cta_click', cta_id: cta, page_path: window.location.pathname });
      }
    },
    { capture: true, passive: true }
  );
}
